import { pdfjs } from "react-pdf";

export const PDF_VIEWER_OPTIONS = {
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
};

export const A4_WIDTH = 595;
export const A4_HEIGHT = 842;
export const A4_RATIO = A4_WIDTH / A4_HEIGHT;
